import scrollSmooth from './scrollSmooth'
import { calcEndPoint } from './tools'
import anchorScroll from './anchorScroll'
import observe from './observe'

export default {
  to: scrollSmooth,
  calcEndPoint,
  anchorScroll,
  observe,
}



// WEBPACK FOOTER //
// ./src/index.js